import React, { Component } from 'react';
import { pick, reject } from 'lodash/fp';
import { Icon, Button } from 'ui';
import openPopup from 'utils/open_popup';
import { routes } from 'constants/config';
import request from 'utils/request_ajax';
import Loading from 'components/shared/Loading';
import ErrorPage from 'components/shared/ErrorPage';
import SessionInfo from './SessionInfo';
import CustomMessage from './CustomMessage';
import InviteesList from './InviteesList';

class InviteUsers extends Component {
  state = {
    loading: true,
    invitees: [],
    message: '',
    event: { id: null, name: null },
    pageError: false,
    session: {
      id: null,
      start_time: null,
      end_time: null,
      time_zone: null,
      trainer: { id: null, name: null },
      max_attendees: null,
      video_meeting: { url: null, provider: null },
      location: null,
      total_registered: null,
    },
  };

  componentDidMount() {
    const eventId = window.location.href.match(
      /in_person_training\/events\/(\d+)\/sessions\/(\d+)/,
    )[1];
    const sessionId = window.location.href.match(
      /in_person_training\/events\/(\d+)\/sessions\/(\d+)/,
    )[2];

    request
      .get(routes.IN_PERSON_TRAINING.SESSION_INVITATIONS(eventId, sessionId))
      .then(payload => {
        this.setState(prevState => ({
          ...payload,
          event: {
            ...prevState.event,
            id: payload.event.id,
            name: payload.event.name,
            next_session: { location: payload.event.next_session.location },
          },
          session: {
            ...prevState.session,
            id: payload.session.id,
            start_time: payload.session.start_time,
            end_time: payload.session.end_time,
            time_zone: payload.session.time_zone,
            trainer: {
              id: payload.session.trainer.id,
              name: payload.session.trainer.name,
            },
            video_meeting: {
              url: payload.session.video_meeting?.url,
              provider: payload.session.video_meeting?.provider,
            },
            max_attendees: payload.session.max_attendees,
            location: payload.session.location,
            total_registered: payload.session.total_registered,
          },
          loading: false,
        }));
      })
      .catch(() => {
        this.setState({ pageError: true, loading: false });
      });
  }

  addStateEventSession = user => {
    this.setState(state => ({
      invitees: [...state.invitees, user],
    }));
  };

  addInvitee = user => {
    this.setState(state => ({
      invitees: [...state.invitees, user],
    }));
  };

  removeInvitee = invitee => {
    this.setState(state => ({
      invitees: reject(invitee, state.invitees),
    }));
  };

  handleMessageChange = message => {
    this.setState({ message: message.replace(/\r?\n|\r/g, ' ') });
  };

  getEventRoute() {
    return routes.IN_PERSON_TRAINING.EVENT(this.state.event.id);
  }

  handlePreviewEmail = () => {
    openPopup({ name: 'email_preview' }).then(popup => {
      const { session, event } = this.state;
      request
        .postJSON(
          routes.IN_PERSON_TRAINING.INVITATION_PREVIEW(event.id, session.id),
          { message: this.state.message },
          { dataType: 'html' },
        )
        .then(html => {
          const css = popup.document.createElement('style');
          css.innerHTML =
            "body { padding: 5%; background: rgb(244, 244, 244); font: normal 13px/1 'proxima-nova', 'Helvetica Neue', sans-serif;} .maincontain { box-shadow: 0px 1px 1px 0px #ececec; }";
          popup.document.body.innerHTML = html;
          popup.document.body.appendChild(css);
        });
    });
  };

  handleSubmit = () => {
    const { invitees, message, event, session } = this.state;
    this.setState({ loading: true }, () => {
      const invitationUrl = routes.IN_PERSON_TRAINING.SESSION_INVITATIONS(
        event.id,
        session.id,
      );
      request
        .postJSON(invitationUrl, {
          invitees: invitees.map(pick(['id', 'type'])),
          message: message.trim(),
        })
        .then(() => {
          window.location.assign(this.getEventRoute());
        });
    });
  };

  render() {
    if (this.state.pageError) {
      return <ErrorPage />;
    }
    const { invitees, message, loading, event, session } = this.state;
    return (
      <div className="InviteUsersForm">
        <Loading loading={this.state.loading}>
          <SessionInfo event={event} session={session} />
        </Loading>
        <InviteesList
          invitees={invitees}
          onAdd={this.addInvitee}
          onRemove={this.removeInvitee}
        />
        <CustomMessage message={message} onChange={this.handleMessageChange} />
        <div className="d-f jc-sb ai-c mt-24">
          <a className="c-brand-blue fz-bigger" href={this.getEventRoute()}>
            {t('common.cancel')}
          </a>
          <div>
            <button
              type="button"
              className="AssignModal-previewEmailBtn h-td-u td-n fz-bigger mr-16"
              onClick={this.handlePreviewEmail}
              disabled={!this.state.message}
            >
              {t('in_person_training.invite_users.preview_invitation')}
              <Icon name="external-link" />
            </button>
            <Button
              tall
              onClick={this.handleSubmit}
              customColor
              loading={loading}
              disabled={invitees.length === 0}
            >
              {t('in_person_training.invite_users.invite')}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default InviteUsers;
